import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Alert } from 'web-ui-components/lib/molecules/nbas';
import withContent from '../../containers/withContent';
import { notificationTypeMappings } from '../../config/';

import pageContent, { contentPropTypes } from './Notifications.content';
import { clearNotification } from '../../states/notifications/actions';
import { getAllNotifications } from '../../states/notifications/selectors';
import EditTemplateButton from './EditTemplateButton';
import { EnhancedGenericErrors } from './GenericErrors';
import FileUploadErrorsComponent from './FileUploadErrorsComponent';
import FileUploadErrorsBacsComponent from './FileUploadErrorsBacsComponent';
import FileUploadErrorsFPSComponent from './FileUploadErrorsFPSComponent';
import DeletePayeeMsg from './DeletePayeeMsg';

const mapState = (state) => ({
	notifications: getAllNotifications(state),
});

const mapDispatch = (dispatch) => ({
	handleClear: (id) => dispatch(clearNotification(id)),
});

const getContent = (content, notification) => {
	if (!Object.keys(content).includes(notification)) {
		return notification;
	}
	return content[notification];
};

const notificationComponents = {
	missingBen: (props) => <EditTemplateButton {...props} />,
	serviceErrorDuringPaymentUpload: (props) => <EnhancedGenericErrors {...props} />,
	permissionError: (props) => <EnhancedGenericErrors {...props} />,
	backendBenImportError: (props) => <FileUploadErrorsComponent {...props} />,
	backendBenImportWithAllError: (props) => <FileUploadErrorsComponent {...props} />,
	backendBenImportWithAllDuplicates: (props) => <FileUploadErrorsComponent {...props} />,
	backendBenImportWithAllErrorsAndDuplicates: (props) => <FileUploadErrorsComponent {...props} />,
	backendBenImportPartialSuccessWithError: (props) => <FileUploadErrorsComponent {...props} />,
	backendBenCheckingPartialSuccessWithError: (props) => <FileUploadErrorsComponent {...props} />,
	backendBenImportPartialSuccessWithoutError: (props) => <FileUploadErrorsComponent {...props} />,
	frontEndError: (props) => <FileUploadErrorsComponent {...props} />,
	frontEndErrorBacsPayment: (props) => <FileUploadErrorsBacsComponent {...props} />,
	frontEndErrorFPSPayment: (props) => <FileUploadErrorsFPSComponent {...props} />,
	frontEndEmptyFileError: (props) => <FileUploadErrorsComponent {...props} />,
	deletePayee: (props) => <DeletePayeeMsg {...props} />,
};

const renderComponents = (key, props) => notificationComponents[key] && notificationComponents[key](props);

const Notifications = ({ notifications, content, handleClear }) => (
	<div data-test-id="alert-notifications">
		{notifications.map(({ notification, id, params }) => (
			<Alert
				onClose={() => handleClear(id)}
				key={id}
				iconType="CrossSolidLarge"
				type={notificationTypeMappings[notification] || 'tip'}
			>
				{getContent(content, notification)}
				{renderComponents(notification, { notificationId: id, ...params })}
			</Alert>
		))}
	</div>
);

Notifications.defaultProps = {
	notifications: [],
};

Notifications.propTypes = {
	notifications: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			notification: PropTypes.string.isRequired,
		})
	),
	content: PropTypes.shape(contentPropTypes),
	handleClear: PropTypes.func.isRequired,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: pageContent }))(Notifications);
